import { colors, flex, radii, spacing, type } from '../../OpportunityWorkspace.style';

export const root = {
    position: 'relative',
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    marginTop: spacing.sectionGap,
    padding: spacing.contactPadding,
    paddingBottom: spacing.contactPaddingBottom,
    boxSizing: 'border-box',
    borderRadius: radii.banner,
    overflow: 'hidden',
    backgroundColor: colors.contactSurfaceBg,
    border: `1px solid ${colors.contactSurfaceBorder}`,
};

/** Viewports below MUI `lg` (1280px) */
export const rootBelowLg = {
    padding: 16,
    paddingBottom: 24,
};

export const contentRow = (showMailboxArt) => ({
    ...flex.rowWrap,
    gap: 20,
    alignItems: 'flex-start',
    position: 'relative',
    zIndex: 1,
    maxWidth: '100%',
    paddingRight: showMailboxArt ? 200 : 0,
});

export const columnPrimary = {
    ...flex.col,
    gap: 12,
    flex: '1 1 260px',
    maxWidth: 420,
    minWidth: 0,
};

export const columnSecondary = {
    ...flex.col,
    gap: 12,
    flex: '1 1 240px',
    minWidth: 0,
    maxWidth: 580,
};

export const emailRow = {
    ...flex.rowCenter,
    gap: 8,
};

export const mailIcon = {
    fontSize: 20,
    color: colors.textHeading,
    flexShrink: 0,
};

export const dividerLine = {
    width: '100%',
    height: 1,
    backgroundColor: colors.sectionDivider,
};

export const mailboxArt = {
    width: 188,
    height: 188,
    position: 'absolute',
    right: 15,
    bottom: -26,
    objectFit: 'contain',
    pointerEvents: 'none',
    zIndex: 0,
};

export const headingStyle = type.contactHeading;

export const bodyStyle = type.contactBody;

export const linkStyle = type.contactLink;

export const responseStyle = type.contactResponse;
